export default (props, vars) => `Hello, ${props?.['user'].name}`;
